import { cleanPrice } from '../clean-price/clean-price';
var VAT_TO_TAX = {
  not_applicable: 'none',
  0: 'vat0',
  10: 'vat10',
  20: 'vat20'
};
/**
 * Формирует список товаров для отправки в пейкипер
 * https://docs.paykeeper.ru/vozmozhnosti-i-primery-ispolzovaniya/tovary-v-cheke-54-fz/
 * @param {Object} options
 * @param {(null | '0' | '10' | '20' | 'not_applicable')} options.vat Настройка налога на СК (admin/delivery_payment#payment).
 * @param {Array} options.items Список товаров заказа.
 * @param {Object} options.delivery Доставка заказа.
 * @return {string}
 */

export var getPayKeeperCart = function getPayKeeperCart(_ref) {
  var vat = _ref.vat,
      items = _ref.items,
      delivery = _ref.delivery;
  var formattedItems = (items || []).filter(function (_ref2) {
    var subject = _ref2.subject;
    return subject;
  }).map(function (_ref3) {
    var name = _ref3.name,
        price = _ref3.formatted_price,
        quantity = _ref3.quantity,
        total = _ref3.formatted_total;
    return {
      tax: VAT_TO_TAX[vat],
      name: name,
      price: cleanPrice(price),
      quantity: quantity,
      sum: cleanPrice(total)
    };
  });

  if (delivery) {
    var price = cleanPrice(delivery.formatted_price);
    formattedItems.push({
      tax: vat && (vat === 'not_applicable' ? 'none' : 'vat20'),
      name: 'Доставка',
      price: price,
      quantity: 1,
      sum: price,
      item_type: 'service'
    });
  }

  return JSON.stringify(formattedItems);
};